import { render, staticRenderFns } from "./userCurrency.vue?vue&type=template&id=d62c0f5a&"
import script from "./userCurrency.vue?vue&type=script&lang=js&"
export * from "./userCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d62c0f5a')) {
      api.createRecord('d62c0f5a', component.options)
    } else {
      api.reload('d62c0f5a', component.options)
    }
    module.hot.accept("./userCurrency.vue?vue&type=template&id=d62c0f5a&", function () {
      api.rerender('d62c0f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManagement/userCurrency.vue"
export default component.exports